import React, { useState } from "react";
import styled from "styled-components";
import { ReviewsQuery, useReviewsQuery } from "../../generated/graphql";
import { RoundedButton } from "../../components/roundedButton";

const TEXT_TRUNCATE_LENGTH = 100;

export function Reviews() {
  const [{ data, error }] = useReviewsQuery();
  console.log("Fetched reviews:", data, error);
  if (!data || !data.getRunsLast) {
    return null;
  }

  // Filter for all 5-star reviews
  const allFiveStars = data.getRunsLast.filter(
    (review): review is NonNullable<typeof review> =>
      review !== null && review.stars === 5,
  );

  // Show only the last 4
  const reviewsToShow = allFiveStars.slice(-4);

  if (reviewsToShow?.length === 0) {
    return null;
  }

  return (
    <>
      <Container>
        <h2>{"DICONO DI NOI"}</h2>
        <GridContainer>
          {reviewsToShow.map((review, idx) => (
            <ReviewCard key={idx} review={review} />
          ))}
        </GridContainer>
      </Container>
      <CenterButtonContainer>
        <a href="https://www.google.it/maps/place/Automotive+Services/@45.6271517,8.9490392,10z/data=!4m8!3m7!1s0x22dcd473cd95b48d:0x603c1820f6de4f9c!8m2!3d45.6271517!4d8.9490392!9m1!1b1!16s%2Fg%2F11s3rhwgwl?entry=ttu&g_ep=EgoyMDI1MDYwOS4wIKXMDSoASAFQAw%3D%3D">
          <RoundedButton className="solid" type="submit">
            SCRIVI UNA RECENSIONE
          </RoundedButton>
        </a>
      </CenterButtonContainer>
    </>
  );
}

// Separate component to handle truncation and expansion
function ReviewCard({
  review,
}: {
  review: NonNullable<ReviewsQuery["getRunsLast"]>[0];
}) {
  const [expanded, setExpanded] = useState(false);
  if (!review) {
    return null;
  }
  const reviewName = review.name || "Cliente";
  const reviewText = review.text || "";
  const reviewerPhotoUrl = review.reviewerPhotoUrl || "";
  const stars = review.stars || 0;
  const isLong = reviewText.length > TEXT_TRUNCATE_LENGTH;
  const displayText =
    expanded || !isLong ?
      reviewText
    : reviewText.slice(0, TEXT_TRUNCATE_LENGTH) + "...";

  return (
    <Card>
      <Avatar
        src={
          "https://automotive-services.netlify.app/.netlify/images?url=" +
          reviewerPhotoUrl +
          "&h=300"
        }
        alt={reviewName}
      />
      <Name>{reviewName}</Name>
      <StarContainer>
        {Array.from({ length: stars }).map((_, i) => (
          <Star key={i}>★</Star>
        ))}
      </StarContainer>
      <Text>{displayText}</Text>
      {isLong && (
        <TextButton onClick={() => setExpanded(!expanded)}>
          {expanded ? "Show Less" : "See More"}
        </TextButton>
      )}
    </Card>
  );
}

// Styled Components
const Container = styled.div`
  padding: 0 4em;

  @media (max-width: 600px) {
    padding: 0 2em;
  }
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;

  @media (min-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const Card = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
const CenterButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 1rem;
`;

const Avatar = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 0.75rem;
`;

const Name = styled.h3`
  font-size: 1.1rem;
  margin: 0.25rem 0;
  color: #333;
`;

const StarContainer = styled.div`
  margin: 0.5rem 0;
`;

const Star = styled.span`
  font-size: 1rem;
  color: #f5a623;
  margin: 0 2px;
`;

const Text = styled.p`
  font-size: 0.95rem;
  color: #555;
  margin-top: 0.5rem;
`;

const TextButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-top: 0.5rem;
  font-size: 0.95rem;
  color: #007bff;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
